import React from 'react'
import { Button } from '@alifd/next'
import styles from './index.module.scss'
import { research } from 'portal/assets/images/index'

interface ResearchTrainingProps {
  image: string,
  title: string,
  state: string,
}

interface LiveBroadcastProps {
  time: string,
  theme: string,
}

export default function ResearchTraining() {
  const learningCourses: ResearchTrainingProps[] = [
    {
      image: research,
      title: '单样本分析，统计方法如何选？',
      state: '2020-06-01学习至第3节',
    },
    {
      image: research,
      title: '横断面研究和病例对照研究',
      state: '2020-06-01学习过',
    },
    {
      image: research,
      title: '详解PICOS原则的研究结构',
      state: '猜你感兴趣',
    }
  ]

  const liveBroadcast: LiveBroadcastProps[] = [
    {
      time: '2020年12月18日 16:00',
      theme: '队列研究和随机对照试验',
    },
    {
      time: '2020年06月18日 13:00',
      theme: '详解PICOS原则的研究结构',
    },
    {
      time: '2020年05月12日 12:00',
      theme: '横断面研究和病例对照研究',
    },
    {
      time: '2020年05月12日 12:00',
      theme: '队列研究和随机对照试验',
    },
  ]

  function learning(props: ResearchTrainingProps) {
    const { image, title, state } = props
    return(
      <div className={ styles.learningCard }>
        <img src={ image } alt="学习提升" style={{ width: 259, height: 168 }} />
        <h5>{ title }</h5>
        <p>{ state}</p>
      </div>
    )
  }

  function liveBroadcastList(props: LiveBroadcastProps) {
    const { time, theme } = props
    return(
      <ul>
        <li style={{ color: '#95a4bd' }}>{ time }</li>
        <li style={{ color: '#333', fontSize: 14, padding: '10px 0' }}>{ theme }</li>
      </ul>
    )
  }
  return (
    <div className={ styles.researchTraining}>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '50px 0 30px' }}>
        <h2>学习提升<span> Research Training</span></h2>
        <div className={ styles.buttons }>
          <Button type="primary">为你推荐</Button>
          <a href="/apps/edu" target="_blank" rel="noopener noreferrer">
            <Button style={{ border: 'none', background: 'none', color: '#202d4c' }}>所有课程</Button>
          </a>
          <a href="/apps/edu?path=/account/studies" target="_blank" rel="noopener noreferrer">
            <Button style={{ border: 'none', background: 'none', color: '#202d4c' }}>我的课程</Button>
          </a>
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ background: '#fff', width: 860, height: 336, display: 'flex', padding: 30 }}>
          { learningCourses.map(learning) }
        </div>
        <div className={ styles.liveBroadcast }>
          <h3 style={{ fontSize: 20, color: '#202d4c', padding: '30px 0 20px 30px', margin: 0 }}>近期直播</h3>
          { liveBroadcast.map(liveBroadcastList) }
        </div>
      </div>
    </div>
  )
}
